import React from 'react';
import type { TAppName } from 'types/app.type';
import type { TObjectType } from 'types/state.interface';
import { Collapse } from '@timeedit/ui-components/antd';
import FieldMapping from './FieldMapping';
import MappingSelector from './MappingSelector';
import PanelHeader from './PanelHeader';
import PreviewTable from './PreviewTable';
import './ObjectTypeMapping.scss';

type ObjectTypeMappingProps = {
  appName: TAppName;
  objectType: TObjectType;
  objectTypeIdx: number;
  allowedMappingModes?: [string];
  showPreview?: boolean;
};

const ObjectTypeMapping = ({
  appName,
  objectType,
  objectTypeIdx,
  allowedMappingModes,
  showPreview,
}: ObjectTypeMappingProps) => {
  return (
    <div className="object-type-mapping--wrapper">
      <Collapse bordered={false} defaultActiveKey={[]}>
        <Collapse.Panel
          header={
            <PanelHeader
              appName={appName}
              objectType={objectType}
              objectTypeIdx={objectTypeIdx}
            />
          }
          key="1"
        >
          <MappingSelector
            appName={appName}
            objectType={objectType}
            objectTypeIdx={objectTypeIdx}
            allowedMappingModes={allowedMappingModes}
          />
          {objectType && objectType.objectTypeExtId && (
            <FieldMapping
              appName={appName}
              objectType={objectType}
              objectTypeIdx={objectTypeIdx}
            />
          )}
          {showPreview !== false && (
            <PreviewTable appName={appName} objectType={objectType} />
          )}
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

export default ObjectTypeMapping;
